var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1190,
    height: 1432,
    viewBox: "55 80 1190 1432",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man / Legs / 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shoes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shoes_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.564 1196.95L263.446 1140.87L242.296 1084.15L112 1181.33L217.548 1366.39C217.548 1366.39 220.94 1320.4 215.42 1269.46C211.608 1234.26 202.564 1196.95 202.564 1196.95ZM789.205 1319.46L775.301 1274.44L716.431 1277.56L765.427 1401.21L953.629 1291.69C897.779 1274.71 789.205 1319.46 789.205 1319.46Z",
    fill: "#0D0B6D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skin legs"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.099 1155.16L241.405 1084.09L166.413 1141.1L202.563 1196.95L248.099 1155.16ZM777.749 1282.05L719.547 1287.31L741.033 1339.64L789.205 1319.46L777.749 1282.05Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pants"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pants_2",
    d: "M667.463 565.502L829.825 1294.64L785.105 1306.1H785.085L733.025 1319.46L732.765 1319.52L714.745 1324.14C714.745 1324.14 632.025 1062.04 559.203 828.221C541.483 857.2 521.524 885.84 499.062 913.699C339.484 1111.62 241.844 1196.22 241.844 1196.22L227.324 1174.24L227.284 1174.18L192.384 1121.36L167.144 1083.16C167.144 1083.16 385.664 875.999 483.984 584.579C466.703 527.841 454.723 487.339 451.645 474.379C434.025 400.479 433.665 366.619 433.665 363.919H622.585L698.344 363.919C695.584 412.079 687.964 483.699 667.464 565.499L667.463 565.502Z",
    fill: "#19141E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Overlay"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M829.825 1294.64L785.105 1306.1H785.085L733.025 1319.46L732.765 1319.52L714.745 1324.14C714.745 1324.14 632.025 1062.04 559.203 828.219C530.783 736.939 503.883 649.979 483.985 584.579C466.703 527.841 454.723 487.339 451.645 474.379C434.025 400.479 433.665 366.619 433.665 363.919H622.585L667.463 565.499L829.825 1294.64Z",
    fill: "white",
    fillOpacity: 0.1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.c4cb809a.svg";
export { ForwardRef as ReactComponent };